(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBHeadendController', HeadendController);
    window.localStorage.removeItem("DataTables_nasracheadendbar_/");
    HeadendController.$inject = ['$scope', '$state','Headend','$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'Principal', 'AuthServerProvider'];

    function HeadendController($scope, $state,Headend,$q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, Principal, AuthServerProvider ) {

        var vm = this;

        vm.headends = [];

        vm.headend = {
        		createHeadendRoles: "Administrators,Billing Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/headends/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {

                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
                    //data.columns[1].data = "emailAddress";
                    data.columns.shift();
                    //data.columns.splice(17);
                    data.order[0].column = data.order[0].column-1;
                    data.columns[1].data="office.officeName";
                    data.columns[0].data="office.mso.msoName";
                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                },
            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withButtons([
                {
                    //extend: 'csvHtml5', // removing action column TODO : remove action header
                    text:'Export',
                    key:'1',

                    /*exportOptions: {
                     columns: [1, 2, 3]
                     }*/
                    action: function (e, dt, node, config) {
                        Headend.download().$promise
                            .then(function (data) {
//                    	console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_ChannelMap.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    }
                }
            ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
            DTColumnBuilder.newColumn('officeMsoName').withTitle('MSO Name'),
            DTColumnBuilder.newColumn('officeOfficeName').withTitle('Office Name'),
            DTColumnBuilder.newColumn('bsiCode').notVisible().withTitle('Bsi Code'),
            DTColumnBuilder.newColumn('headendType').withTitle('Channel Map Type'),
            DTColumnBuilder.newColumn('headendName').withTitle('Channel Map Name'),
            DTColumnBuilder.newColumn('headendCity').withTitle('Headend City'),
            DTColumnBuilder.newColumn('usingNonMotCode').withTitle('Using Non AURORA NETWORKS Code'),
            DTColumnBuilder.newColumn('nctcMember').withTitle('NCTC Member'),
            DTColumnBuilder.newColumn('nctcMemberId').withTitle('NCTC Member Id'),
            DTColumnBuilder.newColumn('nctcSystemId').withTitle('NCTC System Id'),
            DTColumnBuilder.newColumn('boxFeeMot').withTitle('Box Fee AURORA NETWORKS'),
            DTColumnBuilder.newColumn('boxFeeNonMot').withTitle('Box Fee Non AURORA NETWORKS'),
            DTColumnBuilder.newColumn('dtaFee').withTitle('DTA Fee'),
            DTColumnBuilder.newColumn('minimumFee').withTitle('Minimum Fee'),
            DTColumnBuilder.newColumn('downlinkLocation').withTitle('Downlink Location'),

        ];

        if (Principal.hasAnyAuthority(['Billing User'])){
        	vm.dtColumns[0].visible = false;
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();
